/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_To_Lower_CaseInputs */

const en_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Lower Case`)
};

const fr_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte en minuscules`)
};

const de_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text in Kleinbuchstaben umwandeln`)
};

const it_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo in minuscolo`)
};

const ru_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст в нижнем регистре`)
};

const es_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a minúsculas`)
};

const zh_cn2_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转换为小写`)
};

const ja_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを小文字にする`)
};

const hi_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को लोअर केस में बदलें`)
};

const pt_pt2_text_to_lower_case = /** @type {(inputs: Text_To_Lower_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para minúsculas`)
};

/**
* | output |
* | --- |
* | "Text to Lower Case" |
*
* @param {Text_To_Lower_CaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_to_lower_case = /** @type {((inputs?: Text_To_Lower_CaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_To_Lower_CaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_to_lower_case(inputs)
	if (locale === "de") return de_text_to_lower_case(inputs)
	if (locale === "it") return it_text_to_lower_case(inputs)
	if (locale === "ru") return ru_text_to_lower_case(inputs)
	if (locale === "es") return es_text_to_lower_case(inputs)
	if (locale === "zh-CN") return zh_cn2_text_to_lower_case(inputs)
	if (locale === "ja") return ja_text_to_lower_case(inputs)
	if (locale === "hi") return hi_text_to_lower_case(inputs)
	if (locale === "pt-PT") return pt_pt2_text_to_lower_case(inputs)
	return en_text_to_lower_case(inputs)
});